
<!---<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
        <form data-vv-scope="addResetScope">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
                   <img src="@/assets/images/logo/TW_logo.svg" alt="login" style="height:150px;width:150px;" class="mx-auto">
                    <img src="@/assets/images/logo/TraqWorx_Logo.svg" alt="login" style="height:50%;width:75%;" class="mx-auto">

            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">


                  <vs-divider><h3 class="mb-4">Agency Admin</h3></vs-divider>

                <div>

                      <vs-input
                      name="Password"
                      type="password"
                      ref="Password"
                      data-vv-name="Password"
                      v-validate="'required|min:8'"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="New Password"
                      v-model="password"
                      class="w-full"/>
                        <div v-if="errors.has('addResetScope.Password')"
                          style="color:red;"
                        class="invalid-feedback">{{ errors.first('addResetScope.Password') }}</div>
                      <vs-input
                      name="Confirm_Password"
                      data-vv-name="Confirm_Password"
                      type="password"
                      v-validate="'required|min:8|confirmed:Password'"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Confirm Password"
                      v-model="password_confirmation"
                      class="w-full"/>
                      <span class="text-danger" v-show="errors.has('addResetScope.Confirm_Password')">{{ errors.first('addResetScope.Confirm_Password') }}</span>
                      <br>

                      <vs-button type="border"
                          :to="{name: 'forgot-password'}"
                        class="px-4 w-full md:w-auto">Back</vs-button>
                      <vs-button @click="forgotPassword" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Recover Password</vs-button>


                   <br><br>

                  <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                    <h5 class="mb-4 text-center" v-if="error">Something Went Wrong</h5>
                  </div>

                  <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                    <h5 class="mb-4 text-center" v-if="message">Your Password Is Changed Successfully</h5>
                  </div>

                </div>

              </div>
            </div>
          </div>
          </form>
        </div>
      </vx-card>
    </div>
  </div>
</template>--->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                  <form  data-vv-scope="addResetScope">
                    <div class="flex flex-wrap items-center">
                       <div class="lg:block lg:w-1/2 w-full">
                            <img src="@/assets/images/logo/web-logo.png" alt="login" style="width: 80%;" class="mx-auto">
                        </div>

                        <div class="w-full lg:w-1/2 d-theme-dark-bg flex flex-col justify-center">
                           <div class="p-8 ">

                            <vs-divider><h3 class="mb-4">School Admin</h3></vs-divider>


                                <vs-input
                                name="Password"
                                type="password"
                                ref="Password"
                                data-vv-name="Password"
                                v-validate="'required|min:8'"
                                icon-no-border
                                icon="icon icon-lock"
                                icon-pack="feather"
                                label-placeholder="New Password"
                                v-model="password"
                                class="w-full"/>
                                    <div v-if="errors.has('addResetScope.Password')"
                                    style="color:red;"
                                    class="invalid-feedback">{{ errors.first('addResetScope.Password') }}</div>
                                <vs-input
                                name="Confirm_Password"
                                data-vv-name="Confirm Password"
                                type="password"
                                v-validate="'required|min:8|confirmed:Password'"
                                icon-no-border
                                icon="icon icon-lock"
                                icon-pack="feather"
                                label-placeholder="Confirm Password"
                                v-model="password_confirmation"
                                class="w-full"/>
                                <span class="text-danger" v-show="errors.has('addResetScope.Confirm Password')">{{ errors.first('addResetScope.Confirm Password') }}</span>
                                <br>

                                <vs-button type="border"
                                    :to="{name: 'forgot-password'}"
                                    class="px-4 w-full md:w-auto">Back</vs-button>
                                <vs-button @click="forgotPassword" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"> {{ this.$route.query.type=='WELCOME'?'Set Password':'Change Password'}}</vs-button>


                            <br><br>

                            <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                                <h5 class="mb-4 text-center" v-if="error">Something Went Wrong</h5>
                            </div>

                            <div class="vx-card__title mb-4" vs-type="flex" vs-justify="center" vs-align="center">
                                <h5 class="mb-4 text-center" v-if="message">Your Password Is Changed Successfully</h5>
                            </div>


                            </div>
                        </div>

                    </div>
                  </form>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
// import allServices from "../../services/allServices";
import {ResetForgetPassword} from '@/api/login'

export default{


  data () {
    return {

      // email : this.$route.params.email,
      password: '',
      password_confirmation:'',
      error: false,
      message: false,
      email: '',
      token:''
    }
  },
  mounted () {
    this.email = this.$route.query.email
    this.token = this.$route.query.token

    if (!this.email) {
      this.$router.push({name: 'forgot-password'})
    }
  },
  methods : {
    forgotPassword () {
    // const urlParams = new URLSearchParams(window.location.search)
    // this.email = this.$route.params

      const data = {
        token: this.token,
        email:decodeURIComponent(this.email),
        password:this.password
      }


      this.$validator.validateAll('addResetScope').then(valid => {
        if (valid) {
          this.sendForgotData(data)
        } else {
          this.$vs.notify({
            title: 'Waring',
            text: 'Validation is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })

    },
    async sendForgotData (data) {


      const payload = data


      try {

        await ResetForgetPassword(payload)
        //
        this.$vs.notify({
          title: 'Success',
          text: 'Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        // data['attribute'].attribute_id = data.id
        this.$router.push({name: 'page-login'})


      } catch (e) {

        this.$vs.notify({
          title: 'Waring',
          text: 'Something went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

      }
    }

  }


}
</script>

<style lang="scss">


</style>
